import { StatusEnum } from './status';
import { IStudentDTO } from './student';
import { IStudentAssignmentDTO } from './student-assignment';

export enum AssignmentStatusEnum {
  ASSIGNED = 'Assigned',
  UNASSIGNED = 'Unassigned',
  COMPLETED = 'Completed',
}

export interface IClassroomAssignmentListItemDTO {
  assignmentId: number;
  classroomId: string;
  gradeUnitId: number;
  gradeUnitDayId: number;
  dueDate: Date;
}

export interface IClassroomAssignmentDayUnitListItemDTO {
  id?: number;
  classroomId?: string;
  gradeUnitDayId: number;
  dayTitle: string;
  dayNumber: number;
  dayStartPage: string;
  dayEndPage: string;
  dayStatus: StatusEnum;
  gradeUnitId: number;
  unitId: number;
  isQuiz: boolean;
  dayCoverImageId: string;
  dayCoverImageUrl: string;
  bucket: string;
  key: string;
  fileName: string;
  gradeUnitDayStatus: AssignmentStatusEnum;
  assignmentDueDate: Date;
  classroomAssignmentId: number;
  assignmentId: number;
  enrolledStudents: IStudentDTO[];
  studentAssignment: IStudentAssignmentDTO[];
}

export class ClassroomAssignmentDayUnitListItemDTO
  implements IClassroomAssignmentDayUnitListItemDTO
{
  gradeUnitDayId: number = 0;
  dayTitle: string = '';
  dayNumber: number = 0;
  dayStartPage: string = '';
  dayEndPage: string = '';
  isQuiz: boolean = false;
  dayStatus: StatusEnum = StatusEnum.NULL_STATUS;
  gradeUnitId: number = 0;
  unitId: number = 0;
  dayCoverImageId: string = '';
  dayCoverImageUrl: string = '';
  bucket: string = '';
  key: string = '';
  fileName: string = '';
  gradeUnitDayStatus: AssignmentStatusEnum = AssignmentStatusEnum.UNASSIGNED;
  assignmentDueDate: Date = new Date();
  classroomAssignmentId: number = 0;
  assignmentId: number = 0;
  enrolledStudents: IStudentDTO[] = [];
  studentAssignment: IStudentAssignmentDTO[] = [];

  constructor(
    configOverride?: Partial<IClassroomAssignmentDayUnitListItemDTO>,
  ) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
